import React from 'react';

import { ApiUrl } from '../../project/Defines';

import ListView from '../../Shared/ListView';
import { COLUMN_TYPE } from '../../Shared/ListView/helper';
import { EVENT_NAME } from '../../project/utilities';
import { PopupClasses, PopupTypes } from '../../components/Popup';

export default function Version() {
    const columns = [
        {
            text: 'text.version',
            field: 'number',
            type: COLUMN_TYPE.TEXT
        },
        {
            text: 'text.comments',
            field: 'comment',
            render: (text, record) => {
                const _text = text.indexOf('\n') < 0 ? text : text.slice(0, text.indexOf('\n'));
                return <wrap>
                    <text>{_text}</text>
                </wrap>
            },
            type: COLUMN_TYPE.TEXT
        },
        {
            type: COLUMN_TYPE.ACTION
        }
        
    ];

    return (
        <div className="form_container">
            <ListView
                columnConfig={columns}
                // dataSource={[]}
                apiUrl={ApiUrl.VersionList}
                deleteUrl={ApiUrl.VersionDelete}
                //detailUrl={Project.getPageUrl(AppPages.VersionDetails)}
                detailProps={{ fullScreen: false, popupType: PopupTypes.AquamedVersion, className: PopupClasses.Medium, windowKey: 'wndAquamedVersionDetail' }}
                listUpdateEvent={EVENT_NAME.VERSION_LIST_UPDATE}
                nameField='number'
            
            />
        </div>
    );
}
